var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Input } from 'semantic-ui-react';
import { CrossIcon, SearchIcon } from './Icons';


export var SearchBox = function (_a) {
    var onClear = _a.onClear, onChange = _a.onChange, value = _a.value, placeholder = _a.placeholder, _b = _a.size, size = _b === void 0 ? 'small' : _b, onClick = _a.onClick, disabled = _a.disabled, onBlur = _a.onBlur, baseSearchBoxProps = __rest(_a, ["onClear", "onChange", "value", "placeholder", "size", "onClick", "disabled", "onBlur"]);
    var className = "pluggy search-box " + size + " " + (value ? 'filled' : '') + " " + (disabled ? 'disabled' : '');
    return (React.createElement("div", { className: className },
        React.createElement(Input, __assign({}, baseSearchBoxProps, { onChange: onChange, onClick: onClick, placeholder: placeholder, disabled: disabled, onBlur: onBlur, input: React.createElement("input", { className: 'pluggy search-box-input', value: value }) })),
        value && onClear !== undefined ? (React.createElement(CrossIcon, { onClear: onClear, className: 'search-box-icon' })) : (React.createElement(SearchIcon, { className: 'search-box-icon' }))));
};
